import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var ThankyouView = /** @class */ (function (_super) {
    tslib_1.__extends(ThankyouView, _super);
    function ThankyouView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ThankyouView.prototype, "bodyStyles", {
        get: function () {
            return {
                "background-image": "url('" + this.$ui.texts.thankyouText.images[0] + "')"
            };
        },
        enumerable: true,
        configurable: true
    });
    ThankyouView = tslib_1.__decorate([
        Component
    ], ThankyouView);
    return ThankyouView;
}(Vue));
export default ThankyouView;
